import invoiceModule from '../module.js'

invoiceModule.directive('privilegeDropdown', ['httpRequest', 'dictService', (httpRequest, dictService) => ({
    scope: {
        goods: '<',
        privilegeChange: '&',
    },
    template: `
        <div class="dropdown">
          <div class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ng-click="queryTaxRateArr()">
            <span class="et-taxrate-dropdown" title="{{goods.privilegeObj.enumName}}" >
                {{goods.privilegeObj.enumName}}
            </span>
            <span class="caret" style="float:left;margin-top: 10px;margin-left:2px"></span>
          </div>
          <ul class="dropdown-menu" ng-show="goods.privilegeActive" style="min-width: 100px;">
            <li ng-repeat="m in goods.privilegeArr" ng-class="{active:m.enumCode==goods.isPrivilege}" style="text-align: left;padding-left: 5px;">
            <a href="javascript:;" ng-click="selectTaxRate(m)" style="padding-left: 5px;">{{m.enumName}}</a> </li>
          </ul>
        </div>
    `,
    replace: true,
    link (scope) {
        scope.queryTaxRateArr = function queryTaxRateArr () {
            const { goods } = scope
            goods.privilegeActive = true
        }
        scope.selectTaxRate = function selectTaxRate (privilegeObj) {
            const { goods } = scope
            goods.privilegeObj = privilegeObj
            goods.isPrivilege = privilegeObj.enumCode
            scope.privilegeChange && scope.privilegeChange(goods)
        }
    }
})])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/privilegeDropdown.js